import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID && {
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  }),
};

// A missing or rejected web config must not take down the whole app. Login and
// signup import this module at startup; getAuth() throws auth/invalid-api-key
// before React renders, which is the blank page.
let app = null;
let auth = null;
let analytics = null;
let db = null;

if (firebaseConfig.apiKey) {
  try {
    app = initializeApp(firebaseConfig);
    analytics =
      firebaseConfig.measurementId && typeof window !== "undefined"
        ? getAnalytics(app)
        : null;
    auth = getAuth();
    auth.useDeviceLanguage();
    auth.tenantId = null;
    db = getFirestore(app);
  } catch (error) {
    console.error("Firebase failed to initialize:", error);
    app = null;
    auth = null;
    analytics = null;
    db = null;
  }
}

export { auth, analytics, db };
export default app;

/** User closed the OAuth popup or opened a second one — expected, not an application error. */
export function isFirebasePopupDismissal(error) {
  const code = error?.code;
  return (
    code === "auth/popup-closed-by-user" ||
    code === "auth/cancelled-popup-request"
  );
}
